import type { LeadFlow } from '@/data'
import api from '..'

export async function getFlow(slug: string): Promise<LeadFlow | null> {
  const res = await api.get(`/flows/${slug}`)
  return res.data.data
}
